import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "socialpacket _container"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"socialpacket__header\"><div class=\"socialpacket__title text-bold-title\"> Корпоративные привилегии </div><div class=\"socialpacket__header--actions\"><div class=\"swiper-button-next social-button-next\"></div><div class=\"swiper-button-prev social-button-prev\"></div></div></div>", 1)
const _hoisted_3 = {
  key: 0,
  class: "socialpacket__loader"
}
const _hoisted_4 = { class: "socialpacket__loader--card-skeleton" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("rect", {
  x: "24",
  y: "24",
  rx: "0",
  ry: "0",
  width: "159",
  height: "20"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("rect", {
  x: "24",
  y: "48",
  rx: "0",
  ry: "0",
  width: "99",
  height: "20"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("rect", {
  x: "24",
  y: "72",
  rx: "0",
  ry: "0",
  width: "129",
  height: "20"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("rect", {
  x: "200",
  y: "13",
  rx: "16",
  ry: "16",
  width: "140",
  height: "175"
}, null, -1)
const _hoisted_9 = { class: "socialpacket__loader--card-skeleton" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("rect", {
  x: "24",
  y: "24",
  rx: "0",
  ry: "0",
  width: "159",
  height: "20"
}, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("rect", {
  x: "24",
  y: "48",
  rx: "0",
  ry: "0",
  width: "99",
  height: "20"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("rect", {
  x: "24",
  y: "72",
  rx: "0",
  ry: "0",
  width: "129",
  height: "20"
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("rect", {
  x: "200",
  y: "13",
  rx: "16",
  ry: "16",
  width: "140",
  height: "175"
}, null, -1)
const _hoisted_14 = { class: "socialpacket__loader--card-skeleton" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("rect", {
  x: "24",
  y: "24",
  rx: "0",
  ry: "0",
  width: "159",
  height: "20"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("rect", {
  x: "24",
  y: "48",
  rx: "0",
  ry: "0",
  width: "99",
  height: "20"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("rect", {
  x: "24",
  y: "72",
  rx: "0",
  ry: "0",
  width: "129",
  height: "20"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("rect", {
  x: "200",
  y: "13",
  rx: "16",
  ry: "16",
  width: "140",
  height: "175"
}, null, -1)
const _hoisted_19 = { class: "socialpacket__loader--card-skeleton" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("rect", {
  x: "24",
  y: "24",
  rx: "0",
  ry: "0",
  width: "159",
  height: "20"
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("rect", {
  x: "24",
  y: "48",
  rx: "0",
  ry: "0",
  width: "99",
  height: "20"
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("rect", {
  x: "24",
  y: "72",
  rx: "0",
  ry: "0",
  width: "129",
  height: "20"
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("rect", {
  x: "200",
  y: "13",
  rx: "16",
  ry: "16",
  width: "140",
  height: "175"
}, null, -1)
const _hoisted_24 = { class: "socialpacket__loader--card-skeleton" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("rect", {
  x: "24",
  y: "24",
  rx: "0",
  ry: "0",
  width: "159",
  height: "20"
}, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("rect", {
  x: "24",
  y: "48",
  rx: "0",
  ry: "0",
  width: "99",
  height: "20"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("rect", {
  x: "24",
  y: "72",
  rx: "0",
  ry: "0",
  width: "129",
  height: "20"
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("rect", {
  x: "200",
  y: "13",
  rx: "16",
  ry: "16",
  width: "140",
  height: "175"
}, null, -1)
const _hoisted_29 = {
  key: 1,
  class: "socialpacket__carousel"
}
const _hoisted_30 = ["onClick"]
const _hoisted_31 = { class: "carousel--item__text--container" }
const _hoisted_32 = { class: "carousel--item__text text-bold" }
const _hoisted_33 = { class: "carousel--item__img socialpacket__carousel--item-img" }
const _hoisted_34 = ["onLoad", "src"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("rect", {
  x: "24",
  y: "24",
  rx: "0",
  ry: "0",
  width: "159",
  height: "20"
}, null, -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("rect", {
  x: "24",
  y: "48",
  rx: "0",
  ry: "0",
  width: "99",
  height: "20"
}, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("rect", {
  x: "24",
  y: "72",
  rx: "0",
  ry: "0",
  width: "129",
  height: "20"
}, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("rect", {
  x: "200",
  y: "8",
  rx: "10",
  ry: "16",
  width: "140",
  height: "175"
}, null, -1)

import store from '@/store'
import { computed, onUpdated } from 'vue'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Navigation, Mousewheel } from 'swiper'
import { ContentLoader } from 'vue-content-loader'

import 'swiper/css'
import 'swiper/css/navigation'

// const isCardBusy = ref(false)


export default /*#__PURE__*/_defineComponent({
  __name: 'SocialPacket',
  emits: ['social-click-card', 'social-cards-length'],
  setup(__props, { emit }) {



const isCardBusy = computed(() => store.getters.isCardBusy)
const socialCards = computed(() => {
  let data = store.getters.getCardSortItems
  if (
    data !== undefined &&
    data.types !== undefined &&
    data.types[3] !== undefined
  ) {
    return data.types[3]
  }

  return []
})

// watch(cardBusy, (value) => {
//   if (value) {
//     isCardBusy.value = true
//     setTimeout(() => {
//       isCardBusy.value = false
//     }, 500)
//   }
// })

const setCard = (item) => {
  // Устанавливаем карточку
  store
    .dispatch('getCardItem', { filter: { cardId: item.getCardId() } })
    .then(() => {
      // Показываем модальное окно
      emit('social-click-card')
    })
}

const imgLoaded = (el, id) => {
  if (el) {
    // el.path[2].style.display = 'flex'
    let card: HTMLElement | null = document.querySelector(
      `socialpacket__carousel--item-${id}`
    )
    if (card) card.style.display = 'flex'
    let loader: HTMLElement | null = document.querySelector(
      `.socialpacket__loader--card-${id}`
    )
    if (loader) loader.style.display = 'none'
  }
}
const allImgLoaded = () => {
  let card: any = document.querySelectorAll('.socialpacket__carousel--item')
  card.forEach((el) => (el.style.display = 'flex'))
  let loader: any = document.querySelectorAll(`.socialpacket__loader--card`)
  loader.forEach((el) => (el.style.display = 'none'))
}

const beforeSwiper = (swiper) => {
  if (swiper.device.ios) {
    swiper.params.cssMode = true
  }
}

onUpdated(() => {
  let card: any = document.querySelectorAll('.socialpacket__carousel--item')
  card.forEach((el) => (el.style.display = 'flex'))
  let loader: any = document.querySelectorAll(`.socialpacket__loader--card-`)
  loader.forEach((el) => (el.style.display = 'none'))

  emit('social-cards-length', socialCards.value.length)
})

return (_ctx: any,_cache: any) => {
  return (_unref(isCardBusy) || _unref(socialCards).length > 0)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _hoisted_2,
        (_unref(isCardBusy))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_unref(ContentLoader), {
                  viewBox: "0 0 350 200",
                  speed: 2,
                  primaryColor: "#f3f3f3",
                  secondaryColor: "#e2e0e0"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5,
                    _hoisted_6,
                    _hoisted_7,
                    _hoisted_8
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_unref(ContentLoader), {
                  viewBox: "0 0 350 200",
                  speed: 2,
                  primaryColor: "#f3f3f3",
                  secondaryColor: "#e2e0e0"
                }, {
                  default: _withCtx(() => [
                    _hoisted_10,
                    _hoisted_11,
                    _hoisted_12,
                    _hoisted_13
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_unref(ContentLoader), {
                  viewBox: "0 0 350 200",
                  speed: 2,
                  primaryColor: "#f3f3f3",
                  secondaryColor: "#e2e0e0"
                }, {
                  default: _withCtx(() => [
                    _hoisted_15,
                    _hoisted_16,
                    _hoisted_17,
                    _hoisted_18
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_unref(ContentLoader), {
                  viewBox: "0 0 350 200",
                  speed: 2,
                  primaryColor: "#f3f3f3",
                  secondaryColor: "#e2e0e0"
                }, {
                  default: _withCtx(() => [
                    _hoisted_20,
                    _hoisted_21,
                    _hoisted_22,
                    _hoisted_23
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_unref(ContentLoader), {
                  viewBox: "0 0 350 200",
                  speed: 2,
                  primaryColor: "#f3f3f3",
                  secondaryColor: "#e2e0e0"
                }, {
                  default: _withCtx(() => [
                    _hoisted_25,
                    _hoisted_26,
                    _hoisted_27,
                    _hoisted_28
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (!_unref(isCardBusy) && _unref(socialCards)?.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              _createVNode(_unref(Swiper), {
                onImagesReady: allImgLoaded,
                onBeforeInit: beforeSwiper,
                class: "socialSwiper",
                "touch-move-stop-propagation": true,
                "long-swipes-ratio": 0.05,
                threshold: 3,
                mousewheel: {
          forceToAxis: true,
        },
                "slides-per-view": 'auto',
                modules: [_unref(Navigation), _unref(Mousewheel)],
                navigation: {
          nextEl: '.social-button-next',
          prevEl: '.social-button-prev',
        }
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(socialCards), (socialCardItem, idx) => {
                    return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: socialCardItem }, {
                      default: _withCtx(() => [
                        _withDirectives(_createElementVNode("div", {
                          onClick: _withModifiers(($event: any) => (setCard(socialCardItem)), ["stop"]),
                          class: _normalizeClass(["socialpacket__carousel--item carousel--item", 'socialpacket__carousel--item-' + idx])
                        }, [
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, _toDisplayString(socialCardItem.getCardName()), 1)
                          ]),
                          _createElementVNode("div", _hoisted_33, [
                            _createElementVNode("img", {
                              onLoad: (el) => imgLoaded(el, idx),
                              src: socialCardItem.getCardImg(),
                              alt: ""
                            }, null, 40, _hoisted_34)
                          ])
                        ], 10, _hoisted_30), [
                          [_vShow, false]
                        ]),
                        _withDirectives(_createElementVNode("div", {
                          class: _normalizeClass(["socialpacket__loader--card", 'socialpacket__loader--card-' + idx])
                        }, [
                          _createVNode(_unref(ContentLoader), {
                            viewBox: "0 0 347 190",
                            speed: 2,
                            primaryColor: "#f3f3f3",
                            secondaryColor: "#e2e0e0"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_35,
                              _hoisted_36,
                              _hoisted_37,
                              _hoisted_38
                            ]),
                            _: 1
                          })
                        ], 2), [
                          [_vShow, true]
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }, 8, ["long-swipes-ratio", "modules", "navigation"])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})